/**
 * A report's place in its life. It is filed as a `draft`, published by the
 * crag's staff (`accepted`, which is what mails the maintainers), and closed as
 * `resolved`. `rejected` never reaches a reader — the API filters it out.
 */
export type CragReportStatus = 'draft' | 'accepted' | 'resolved' | 'rejected';

/** What is wrong, coarsely. Mirrors the enum on CragReport. */
export type CragReportCategory =
  | 'other'
  | 'bolt'
  | 'anchor'
  | 'rock'
  | 'access'
  | 'vegetation'
  | 'wildlife';

/** Every category, in the order the report form offers them. */
export const CRAG_REPORT_CATEGORIES: CragReportCategory[] = [
  'bolt',
  'anchor',
  'rock',
  'access',
  'vegetation',
  'wildlife',
  'other',
];

/** The line a report is about, when it is about one at all. */
export interface CragReportClimb {
  id: string;
  name: string;
  slug: string;
  type: string;
  grade?: string | null;
  zone_id?: string | null;
}

export interface CragReportReporter {
  id: string;
  username: string;
  slug: string;
  avatar_small_url?: string | null;
}

export interface CragReport {
  id: string;
  status: CragReportStatus;
  category: CragReportCategory;
  description: string;
  /** What staff wrote when they closed it. Only ever set on a resolved one. */
  resolution_message?: string | null;
  created_at: string;
  accepted_at?: string | null;
  resolved_at?: string | null;
  /** Null when the report is about the crag rather than one of its lines. */
  climb?: CragReportClimb | null;
  reported_by?: CragReportReporter | null;
  /** Only on lists that span several crags — a maintainer's page. */
  crag?: { id: string; name: string; slug: string } | null;
}

/** What a reporter fills in. The route is optional, as the report may be. */
export interface CreateCragReportData {
  description: string;
  category: CragReportCategory;
  climb_id?: string | null;
}
